/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import request from 'superagent';
import get from 'lodash/get';
import ls from 'local-storage';
import { isAuthenticated } from '../utils/isAuthenticated';
import { USER_KEY } from '../constants/sharedKeys';

export const V1_ACCEPT_HEADER = 'application/vnd.api.clustertruck.com; version=1';
export const V2_ACCEPT_HEADER = 'application/vnd.api.clustertruck.com; version=2';
export const V3_ACCEPT_HEADER = 'application/vnd.api.clustertruck.com; version=3';
export const V4_ACCEPT_HEADER = 'application/vnd.api.clustertruck.com; version=4';

function getUrl(path) {
    const isPrerender = window.location.host.indexOf('localhost:45678') !== -1;
    const base = isPrerender ? 'https://www.clustertruck.com' : window.ENV.BASE_URL || '';
    return  base + path;
}

function withAuthHeader(headers = {}) {
  const token = get(ls.get(USER_KEY), 'token');
  if(isAuthenticated(token)) {
    headers.Authorization = `Bearer ${token}`;
    headers['X-CT-Token'] = `Bearer ${token}`;
  }
  return headers;
};

function responseHandler(resolve, reject) {
    return (err, res) => {
        if (err) {
            reject(err);
        } else {
            resolve(res.body);
        }
    }
}

const HttpClient = {

    get: (path, headers={}, query={}, accept = V1_ACCEPT_HEADER) => new Promise((resolve, reject) => {
        request
        .get(getUrl(path))
        .query(query)
        .set(withAuthHeader(headers))
        .accept(accept)
        .end(responseHandler(resolve, reject));
    }),

    post: (path, data, headers={}) => new Promise((resolve, reject) => {
        request
        .post(getUrl(path))
        .set(withAuthHeader(headers))
        .send(data)
        .accept('application/json')
        .end(responseHandler(resolve, reject));

    }),

    put: (path, data, headers = {}) => new Promise((resolve, reject) => {
        request
        .put(getUrl(path))
        .set(withAuthHeader(headers))
        .send(data)
        .accept('application/json')
        .end(responseHandler(resolve, reject));
    }),

    del: (path, headers = {}) => new Promise((resolve, reject) => {
        request
        .del(getUrl(path))
        .set(withAuthHeader(headers))
        .accept('application/json')
        .end(responseHandler(resolve, reject));
    }),

    getKitchenStripeConfig: (identifier, headers = {}) => {
        const encodedIdentifier = encodeURIComponent(identifier);

        return HttpClient
          .get(`/api/kitchens/${encodedIdentifier}/stripe_client_config`, headers)
          .catch((error) => {
            const status = get(error, 'status') || get(error, 'response.status');

            if (status === 404) {
              // No custom config for this kitchen, fall back to the default key
              return { publishable_key: null };
            }

            throw error;
          });
    },

    getCreditCards: (franchiseId, headers = {}) => {
        const query = franchiseId ? { franchise_id: franchiseId } : {};

        return HttpClient.get('/api/credit_cards', headers, query);
    },

};

export default HttpClient;
